(function() {
  'use strict';

  var SS_PRODUCTS_KEY = 'swym-wishlist-products';
  var SS_SHARE_URL_KEY = 'swym-share-url';

  function initWishlistPage(swat) {
    // Use the SDK's built-in login check — this is the canonical way.
    // Under the hood, Swym's Liquid snippet sets window.swymCustomerId
    // from Shopify's {{ customer.id }} object. The SDK reads it on init.
    var isLoggedIn = swat.platform.isLoggedIn();
    var isSharePage = (window.wishlistPageHandle || '').includes('share');
    var grid = document.getElementById('swym-wishlist-grid');
    var loading = document.getElementById('swym-wishlist-loading');
    var empty = document.getElementById('swym-wishlist-empty');
    var countEl = document.getElementById('swym-wishlist-count');

    if (!grid) return;

    var currentLid = null;


    // Single delegation listener on the grid — survives re-renders since the ul itself never changes
    grid.addEventListener('click', function(e) {
      var deleteBtn = e.target.closest('.swym-wl-delete');
      if (deleteBtn) {
        var empi = parseInt(deleteBtn.dataset.empi, 10);
        var epi = parseInt(deleteBtn.dataset.epi, 10);
        var du = deleteBtn.dataset.du;
        if (!empi || !epi) return;
        var card = deleteBtn.closest('li');
        swat.deleteFromList(currentLid, { empi: empi, epi: epi, du: du }, function() {
          if (card && card.parentNode) card.parentNode.removeChild(card);

          var cached = null;
          try { cached = JSON.parse(sessionStorage.getItem(SS_PRODUCTS_KEY)); } catch (ex) {}
          var updatedProducts = cached
            ? cached.products.filter(function(p) { return p.epi !== epi; })
            : [];
          sessionStorage.setItem(SS_PRODUCTS_KEY, JSON.stringify({ lid: currentLid, products: updatedProducts }));
          sessionStorage.removeItem(SS_SHARE_URL_KEY);

          var count = updatedProducts.length;
          if (countEl) countEl.textContent = '(' + count + ')';
          setupShareButton(swat, currentLid, count);
          setupClearButton(swat, currentLid, updatedProducts);
          if (count === 0 && empty) {
            grid.innerHTML = '';
            grid.style.display = 'none';
            empty.style.display = 'flex';
          }
        }, function() {});
        return;
      }

      var atcBtn = e.target.closest('.swym-wl-atc');
      if (atcBtn) {
        var variantId = parseInt(atcBtn.dataset.variantId, 10);
        if (!variantId) return;
        atcBtn.disabled = true;
        var origHTML = atcBtn.innerHTML;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        })
        .then(function(res) { return res.json(); })
        .then(function(data) {
          atcBtn.disabled = false;
          if (data.status) return;
          atcBtn.innerHTML = '<i aria-hidden="true" class="icon-check-light"></i>';
          setTimeout(function() { atcBtn.innerHTML = origHTML; }, 3000);
          if (typeof general !== 'undefined' && general.enable_cart_drawer) {
            ajaxCart.load(false, true, false, true);
          } else if (typeof ajaxCart !== 'undefined') {
            ajaxCart.fetchCartCount();
          }
        })
        .catch(function() { atcBtn.disabled = false; });
      }
    });

    // Render immediately from sessionStorage cache if available (skipped on share pages)
    var cachedRaw = !isSharePage ? sessionStorage.getItem(SS_PRODUCTS_KEY) : null;
    var cachedData = null;
    if (cachedRaw) {
      try {
        cachedData = JSON.parse(cachedRaw);
        if (loading) loading.style.display = 'none';
        currentLid = cachedData.lid;
        renderProducts(cachedData.products, grid, empty, cachedData.lid, isLoggedIn);
        if (countEl) countEl.textContent = '(' + cachedData.products.length + ')';
        if (!isSharePage) {
          setupShareButton(swat, cachedData.lid, cachedData.products.length);
          setupClearButton(swat, cachedData.lid, cachedData.products);
        }
      } catch (e) {
        sessionStorage.removeItem(SS_PRODUCTS_KEY);
        cachedData = null;
      }
    }

    // Handles the resolved list state — called after cleanup (if needed) or directly
    function handleLists(lists) {
      if (loading) loading.style.display = 'none';
      var defaultList = lists && lists.length ? lists[0] : null;
      var lid = defaultList ? defaultList.lid : null;
      currentLid = lid;
      var products = defaultList ? (defaultList.listcontents || []) : [];

      var cachedCount = cachedData ? cachedData.products.length : -1;
      var freshCount = products.length;
      var countMismatch = freshCount !== cachedCount;

      sessionStorage.setItem(SS_PRODUCTS_KEY, JSON.stringify({ lid: lid, products: products }));

      if (countMismatch) {
        if (freshCount === 0) {
          _renderGeneration++; // abort any in-flight cache render
          grid.innerHTML = '';
          grid.style.display = 'none';
          if (empty) empty.style.display = 'flex';
          if (countEl) countEl.textContent = '(0)';
          var shareBtn = document.getElementById('swym-share-btn');
          var clearBtn = document.getElementById('swym-clear-btn');
          if (shareBtn) shareBtn.style.display = 'none';
          if (clearBtn) clearBtn.style.display = 'none';
          return;
        }
        if (countEl) countEl.textContent = '(' + freshCount + ')';
        renderProducts(products, grid, empty, lid, isLoggedIn);
        if (!isSharePage) {
          setupShareButton(swat, lid, freshCount);
          setupClearButton(swat, lid, products);
        }
        sessionStorage.removeItem(SS_SHARE_URL_KEY);
      }

    }

    if (isSharePage) {
      var sharedLid = new URLSearchParams(window.location.search).get('lid');
      if (!sharedLid) {
        if (loading) loading.style.display = 'none';
        if (empty) empty.style.display = 'flex';
      } else {
        swat.fetchListDetails({ lid: sharedLid }, function(listDetails) {
          if (loading) loading.style.display = 'none';
          var list = listDetails && listDetails.list ? listDetails.list : null;
          var products = list ? (list.listcontents || []) : [];
          var lid = list ? list.lid : sharedLid;
          currentLid = lid;
          if (products.length === 0) {
            if (empty) empty.style.display = 'flex';
            if (countEl) countEl.textContent = '(0)';
            return;
          }
          if (countEl) countEl.textContent = '(' + products.length + ')';
          renderProducts(products, grid, empty, lid, isLoggedIn);
        }, function(error) {
          console.error('[Swym] fetchListDetails failed:', error);
          if (loading) loading.style.display = 'none';
          if (empty) empty.style.display = 'flex';
        });
      }
    } else {
      // fetchLists gives us the default list lid (needed for sharing) and its
      // contents in one call — no separate swat.fetch needed on initial load.
      swat.fetchLists({
        callbackFn: function(lists) {
          if (lists && lists.length > 1) {
            cleanupLists(swat, lists, function() {
              swat.fetchLists({
                callbackFn: function(freshLists) {
                  sessionStorage.removeItem(SS_PRODUCTS_KEY);
                  cachedData = null;
                  handleLists(freshLists);
                },
                errorFn: function() {
                  if (loading) loading.style.display = 'none';
                }
              });
            });
            return;
          }
          handleLists(lists);
        },
        errorFn: function() {
          if (loading) loading.style.display = 'none';
        }
      });
    }
  }

  var _renderGeneration = 0;

  function renderProducts(products, container, emptyEl, lid, isLoggedIn) {
    var generation = ++_renderGeneration;
    container.setAttribute('aria-busy', 'true');
    container.style.display = 'none';
    container.innerHTML = '';

    if (!products || products.length === 0) {
      if (emptyEl) emptyEl.style.display = 'flex';
      container.setAttribute('aria-busy', 'false');
      return;
    }

    if (emptyEl) emptyEl.style.display = 'none';

    var variantIds = products.map(function(p) { return p.epi; }).join('-');
    var productIds = Array.from(
        new Set(products.map(function(p) { return p.empi; }))
    ).map(function(id) {
        return 'id:' + id;
    }).join(' OR ');

    var isSharePage = (window.wishlistPageHandle || '').includes('share');
    var url = (window.wishListRouteSearchUrl || '/search') + '?type=product'
      + '&variant_ids=' + variantIds
      + '&lid=' + (lid || '')
      + '&list_type=wishlist'
      + '&is_share_wishlist_page=' + (isSharePage ? 'true' : 'false')
      + '&q=' + encodeURIComponent(productIds)
      + '&view=wishlist';

    fetch(url)
      .then(function(res) { return res.json(); })
      .then(function(data) {
        if (generation !== _renderGeneration) return;
        var items = data.items || [];
        items.forEach(function(item) {
          if (!item || !item.html) return;
          var wrapper = document.createElement('div');
          wrapper.innerHTML = item.html;
          while (wrapper.firstChild) {
            container.appendChild(wrapper.firstChild);
          }
        });

        if (!isLoggedIn && !isSharePage) {
          var tpl = document.getElementById('swym-login-nudge-tpl');
          if (tpl) {
            var nudgeCard = tpl.content.cloneNode(true).firstElementChild;
            if (nudgeCard) {
              var rowSize = window.innerWidth > 1000 ? 4 : window.innerWidth > 760 ? 3 : 2;
              var liItems = container.querySelectorAll(':scope > li');
              container.insertBefore(nudgeCard, liItems[rowSize - 1] || null);
            }
          }
        }

        container.style.display = '';
        container.setAttribute('aria-busy', 'false');
        window.scrollTo({ top: 0, behavior: 'smooth' });

        // Re-initialize AJAX cart handlers for the injected quick-buy forms.
        // ajaxCart.init() picks up any form.f8pr / form.form-card not yet
        // marked cart-initialized, which is every form injected after page load.
        if (typeof ajaxCart !== 'undefined') ajaxCart.init();
        window.dispatchEvent(new CustomEvent('listCart'));
        // Re-initialize quickshop popup links ([data-quickshop]) for multi-variant products.
        window.dispatchEvent(new CustomEvent('quickShop'));
        // Re-initialize color swatch image-swap and scrollable list behavior.
        window.dispatchEvent(new CustomEvent('listScrollable'));
        // Re-initialize .update-variants select handlers and Swym button scanning.
        window.dispatchEvent(new CustomEvent('productVariants'));
      })
      .catch(function() {
        if (generation !== _renderGeneration) return;
        container.style.display = '';
        container.setAttribute('aria-busy', 'false');
      });
  }

  function bindShareUrlButtons(modal, copyBtn, url, swat, lid) {
    if (copyBtn) {
      copyBtn.disabled = false;
      var freshCopy = copyBtn.cloneNode(true);
      copyBtn.parentNode.replaceChild(freshCopy, copyBtn);
      freshCopy.addEventListener('click', function() { handleCopyLink(url); });
    }
    modal.querySelectorAll('.swym-share-social-btn').forEach(function(socialBtn) {
      var freshSocial = socialBtn.cloneNode(true);
      socialBtn.parentNode.replaceChild(freshSocial, socialBtn);
      freshSocial.addEventListener('click', function() {
        handleSocialShare(swat, lid, freshSocial.dataset.platform, url);
      });
    });
  }

  function setupShareButton(swat, lid, productCount) {
    var btn = document.getElementById('swym-share-btn');
    if (!btn || !lid) return;

    if (productCount === 0) {
      btn.style.display = 'none';
      return;
    }
    btn.style.display = '';

    // Replace node to clear any listener attached in a previous render pass
    var fresh = btn.cloneNode(true);
    btn.parentNode.replaceChild(fresh, btn);
    fresh.addEventListener('click', function() {
      openShareModal(swat, lid);
    });
  }

  function setupClearButton(swat, lid, products) {
    var btn = document.getElementById('swym-clear-btn');
    if (!btn || !lid) return;

    if (!products || products.length === 0) {
      btn.style.display = 'none';
      return;
    }
    btn.style.display = '';

    var fresh = btn.cloneNode(true);
    btn.parentNode.replaceChild(fresh, btn);
    fresh.addEventListener('click', function() {
      var confirm = document.getElementById('swym-clear-confirm');
      if (!confirm) return;
      confirm.style.display = '';
      showBackdrop();

      var yesBtn = document.getElementById('swym-clear-confirm-yes');
      var noBtn = document.getElementById('swym-clear-confirm-no');
      var freshYes = yesBtn.cloneNode(true);
      var freshNo = noBtn.cloneNode(true);
      yesBtn.parentNode.replaceChild(freshYes, yesBtn);
      noBtn.parentNode.replaceChild(freshNo, noBtn);

      freshNo.addEventListener('click', function() {
        confirm.style.display = 'none';
        hideBackdrop();
      });

      var filteredProductData = products.map(function(p) {
        return { empi: p.empi, epi: p.epi, du: p.du };
      });
      freshYes.addEventListener('click', function() {
        freshYes.disabled = true;
        swat.removeProductsFromList(lid, filteredProductData, function() {
          confirm.style.display = 'none';
          hideBackdrop();
          sessionStorage.removeItem(SS_PRODUCTS_KEY);
          sessionStorage.removeItem(SS_SHARE_URL_KEY);
          var grid = document.getElementById('swym-wishlist-grid');
          var empty = document.getElementById('swym-wishlist-empty');
          var countEl = document.getElementById('swym-wishlist-count');
          if (grid) {
            grid.innerHTML = '';
            grid.style.display = 'none';
          }
          if (empty) empty.style.display = 'flex';
          if (countEl) countEl.textContent = '(0)';
          var shareBtn = document.getElementById('swym-share-btn');
          if (shareBtn) shareBtn.style.display = 'none';
          fresh.style.display = 'none';
        }, function() {
          freshYes.disabled = false;
        });
      });
    });
  }

  function showBackdrop() {
    var bd = document.getElementById('swym-modal-backdrop');
    if (bd) bd.style.display = '';
  }

  function hideBackdrop() {
    var bd = document.getElementById('swym-modal-backdrop');
    if (bd) bd.style.display = 'none';
  }

  function openShareModal(swat, lid) {
    var modal = document.getElementById('swym-share-modal');
    if (!modal) return;

    var nameInput = document.getElementById('swym-share-name-input');
    var emailInput = document.getElementById('swym-share-email-input');
    var noteInput = document.getElementById('swym-share-note-input');
    var copyBtn = document.getElementById('swym-share-copy-btn');
    if (nameInput) nameInput.value = '';
    if (emailInput) emailInput.value = '';
    if (noteInput) noteInput.value = '';
    if (copyBtn) copyBtn.disabled = true;
    modal.querySelectorAll('[id$="-feedback"]').forEach(function(el) { el.style.display = 'none'; });

    modal.style.display = '';
    modal.setAttribute('aria-hidden', 'false');
    showBackdrop();

    var shareContent = document.getElementById('swym-share-content');
    var loginPrompt = document.getElementById('swym-share-login-prompt');
    var isLoggedIn = swat.platform.isLoggedIn();

    if (isLoggedIn) {
      if (loginPrompt) loginPrompt.style.display = 'none';
      if (shareContent) shareContent.style.display = '';

      var cachedShareUrl = sessionStorage.getItem(SS_SHARE_URL_KEY);
      if (cachedShareUrl) {
        bindShareUrlButtons(modal, copyBtn, cachedShareUrl, swat, lid);
      } else {
        swat.markListPublic(lid, function() {
          swat.generateSharedListURL(lid, function(url) {
            sessionStorage.setItem(SS_SHARE_URL_KEY, url);
            bindShareUrlButtons(modal, copyBtn, url, swat, lid);
          }, function(err) {
            console.error('[Swym] generateSharedListURL failed:', err);
            if (copyBtn) copyBtn.disabled = true;
          });
        }, function(err) {
          console.error('[Swym] markListPublic failed:', err);
          if (copyBtn) copyBtn.disabled = true;
        });
      }
    } else {
      if (shareContent) shareContent.style.display = 'none';
      if (loginPrompt) loginPrompt.style.display = '';
    }

    var emailBtn = document.getElementById('swym-share-email-btn');
    if (emailBtn) {
      var freshEmail = emailBtn.cloneNode(true);
      emailBtn.parentNode.replaceChild(freshEmail, emailBtn);
      freshEmail.addEventListener('click', function() { handleEmailShare(swat, lid); });
    }

    var closeBtn = modal.querySelector('.close');
    if (closeBtn) {
      var freshClose = closeBtn.cloneNode(true);
      closeBtn.parentNode.replaceChild(freshClose, closeBtn);
      freshClose.addEventListener('click', function() { closeShareModal(); });
    }

    document.addEventListener('keydown', handleShareModalKeydown);
  }

  function handleShareModalKeydown(e) {
    if (e.key === 'Escape') {
      closeShareModal();
      return;
    }
    if (e.key !== 'Tab') return;
    var modal = document.getElementById('swym-share-modal');
    if (!modal) return;
    var focusable = Array.prototype.slice.call(
      modal.querySelectorAll('button:not([disabled]),input,textarea,select,[tabindex]:not([tabindex="-1"])')
    ).filter(function(el) { return !el.disabled && el.offsetParent !== null; });
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.shiftKey) {
      if (document.activeElement === first) { e.preventDefault(); last.focus(); }
    } else {
      if (document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  }

  function closeShareModal() {
    var modal = document.getElementById('swym-share-modal');
    if (modal) {
      modal.style.display = 'none';
      modal.setAttribute('aria-hidden', 'true');
    }
    hideBackdrop();
    document.removeEventListener('keydown', handleShareModalKeydown);
    var trigger = document.getElementById('swym-share-btn');
    if (trigger) trigger.focus();
  }

  function handleCopyLink(url) {
    var feedback = document.getElementById('swym-share-copy-feedback');
    var done = function() {
      showModalFeedback(feedback);
      setTimeout(closeShareModal, 800);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(done).catch(function() {
        fallbackCopy(url, feedback);
        setTimeout(closeShareModal, 800);
      });
    } else {
      fallbackCopy(url, feedback);
      setTimeout(closeShareModal, 800);
    }
  }

  function handleEmailShare(swat, lid) {
    var nameInput = document.getElementById('swym-share-name-input');
    var emailInput = document.getElementById('swym-share-email-input');
    var noteInput = document.getElementById('swym-share-note-input');
    var emailBtn = document.getElementById('swym-share-email-btn');
    var feedback = document.getElementById('swym-share-email-feedback');
    if (!emailInput) return;

    var email = emailInput.value.trim();
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      emailInput.focus();
      return;
    }

    if (emailBtn) emailBtn.disabled = true;
    swat.sendListViaEmail({
      toEmailId: email,
      note: noteInput ? noteInput.value.trim() : '',
      fromName: nameInput ? nameInput.value.trim() : '',
      lid: lid
    }, function() {
      if (emailBtn) emailBtn.disabled = false;
      if (nameInput) nameInput.value = '';
      emailInput.value = '';
      if (noteInput) noteInput.value = '';
      showModalFeedback(feedback);
      setTimeout(closeShareModal, 1000);
    }, function() {
      if (emailBtn) emailBtn.disabled = false;
    });
  }

  function handleSocialShare(swat, lid, platform, shareUrl) {
    var platformUrlTemplate = '';
    if (platform === 'facebook') platformUrlTemplate = 'https://www.facebook.com/sharer.php?u=' + encodeURIComponent(shareUrl) + '&t=';
    else if (platform === 'twitter') platformUrlTemplate = 'https://twitter.com/share?text=&url=' + encodeURIComponent(shareUrl);
    swat.shareListSocial(lid, '', platformUrlTemplate, platform, '', function() {});
    if (platformUrlTemplate) window.open(platformUrlTemplate, '_blank', 'noopener,noreferrer');
    closeShareModal();
  }

  function showModalFeedback(el) {
    if (!el) return;
    el.style.display = '';
    setTimeout(function() { el.style.display = 'none'; }, 2500);
  }

  function fallbackCopy(url, feedbackEl) {
    var ta = document.createElement('textarea');
    ta.value = url;
    ta.style.cssText = 'position:fixed;opacity:0;pointer-events:none;';
    document.body.appendChild(ta);
    ta.select();
    try { document.execCommand('copy'); showModalFeedback(feedbackEl); } catch (e) {}
    document.body.removeChild(ta);
  }



  // Wishlist runs in single-list mode: list[0] is kept as-is, every other
  // list the shopper has is discarded rather than merged into it.
  function cleanupLists(swat, lists, onDone) {
    var extraLids = lists.slice(1).map(function(l) { return l.lid; });

    function deleteNext(i) {
      if (i >= extraLids.length) { onDone(); return; }
      swat.deleteList(extraLids[i], function() {
        deleteNext(i + 1);
      }, function() {
        deleteNext(i + 1);
      });
    }

    deleteNext(0);
  }

  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(initWishlistPage);
})();